import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SettingsService } from 'src/app/services/account/settings.service';
import { ValueIntegerPipe } from 'src/app/pipes/value-integer.pipe';

@Component({
  standalone: true,
  selector: 'app-speedlimit',
  templateUrl: './speedlimit.component.html',
  styleUrls: ['./speedlimit.component.scss'],
  imports: [CommonModule, ValueIntegerPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpeedlimitComponent {
  @Input() hasTurn: boolean = false;
  @Input() speedLimit: number = 0;
  @Input() floatingInfoVisible: boolean = true;
  @Input() roadLanesVisible: boolean = false;
  @Input() laneInfoCount: number = 0;

  constructor(public settingsService: SettingsService) {
  }
}
